import { matchPath } from "react-router-dom";

export const APP_TITLE = "Elite Core";

const routeTitles = [
  { path: "/", exact: true, title: "Dashboard" },
  { path: "/login", exact: true, title: "Login" },
  { path: "/registration", exact: true, title: "Registration" },
  { path: "/forgot-password", exact: true, title: "Forgot Password" },
  { path: "/forgot-password/:token/:email", exact: true, title: "Reset Password" },
  { path: "/profile/:id/payment-methods", exact: true, title: "Payment Methods" },
  { path: "/profile/:id/ezee-ai", exact: true, title: "Ezee AI Usage" },
  { path: "/profile/:id/change-password", exact: true, title: "Change Password" },
  { path: "/profile/:id", exact: true, title: "Profile" },
  { path: "/product-search", exact: true, title: "Product Search" },
  { path: "/update-log", exact: true, title: "Update Log" },
  { path: "/activity-log", exact: true, title: "Update Log" },
  { path: "/welcome-to-elite-core", exact: true, title: "Welcome" },
  { path: "/new-instance", exact: true, title: "Create Instance" },
  { path: "/instance-manager", exact: true, title: "Instances" },
  { path: "/invoices", exact: true, title: "Invoices" },

  { path: "/generated-sales-order/:id", exact: true, title: ({ id }) => `Sales Order #${id}` },
  { path: "/generated-estimate/:id", exact: true, title: ({ id }) => `Estimate #${id}` },
  { path: "/generated-invoice/:id", exact: true, title: ({ id }) => `Invoice #${id}` },
  { path: "/generated-purchase-order/:id", exact: true, title: ({ id }) => `Purchase Order #${id}` },
  { path: "/generated-proof/:poId/:proofId", exact: true, title: "Artwork Proof" },
  { path: "/generated-proof/:proofId", exact: true, title: "Artwork Proof" },
  { path: "/generated-proofs/order/:orderId", exact: true, title: "Artwork Proofs" },
  { path: "/generated-proofs/:poId", exact: true, title: "Artwork Proofs" },
  { path: "/instance/:instanceUniqueId/purchase-orders/:poId/print/:docType", exact: true, title: "Purchase Order" },

  { path: "/talent/login", exact: true, title: "Talent Login" },
  { path: "/talent/forgot-password", exact: true, title: "Talent Forgot Password" },
  { path: "/talent/reset-password", exact: true, title: "Talent Reset Password" },
  { path: "/talent/change-password", exact: true, title: "Talent Change Password" },
  { path: "/talent/verify-account", exact: true, title: "Verify Talent Account" },
  { path: "/talent/profile", exact: true, title: "Talent Profile" },
  { path: "/talent/assignments/:id", exact: true, title: "Talent Assignment" },
  { path: "/talent/assignments", exact: true, title: "Talent Assignments" },
  { path: "/talent/offers/:id", exact: true, title: "Talent Offer" },
  { path: "/talent/offers", exact: true, title: "Talent Offers" },
  { path: "/talent", exact: true, title: "Talent Portal" },
  { path: "/network/assignments/:id", exact: true, title: "Network Assignment" },
  { path: "/network/assignments", exact: true, title: "Network Assignments" },
  { path: "/network/offers/:id", exact: true, title: "Network Offer" },
  { path: "/network/offers", exact: true, title: "Network Offers" },
  { path: "/network", exact: true, title: "Core Network" },

  {
    path: "/instance/:instanceUniqueId/sales/orders/:orderId/sales-order/:salesOrderId",
    exact: true,
    title: ({ salesOrderId }) => `Sales Order #${salesOrderId}`,
  },
  {
    path: "/instance/:instanceUniqueId/sales/orders/:orderId/estimate/:estimateId",
    exact: true,
    title: ({ estimateId }) => `Estimate #${estimateId}`,
  },
  { path: "/instance/:instanceUniqueId/sales/orders/:orderId/overview", exact: true, title: "Project Overview" },
  { path: "/instance/:instanceUniqueId/sales/orders/:orderId/purchase-orders/:tabId?", exact: true, title: "Purchase Orders" },
  { path: "/instance/:instanceUniqueId/sales/orders/:orderId/:tabtype/:tabId?", exact: true, title: "Order" },
  { path: "/instance/:instanceUniqueId/sales/orders", exact: true, title: "Orders" },
  { path: "/instance/:instanceUniqueId/sales/pipeline", exact: true, title: "Pipeline" },
  { path: "/instance/:instanceUniqueId/presentations/:id", exact: true, title: "Presentation" },
  { path: "/instance/:instanceUniqueId/sales/customers/leads", exact: true, title: "Leads" },
  { path: "/instance/:instanceUniqueId/sales/customers/:view?", exact: true, title: "Customers" },
  { path: "/instance/:instanceUniqueId/sales/prospects", exact: true, title: "Prospects" },
  { path: "/instance/:instanceUniqueId/sales/promostores/marketplace", exact: true, title: "PromoStore Marketplace" },
  { path: "/instance/:instanceUniqueId/sales/promostores/:id/:tabtype?", exact: true, title: "Promo Store" },
  { path: "/instance/:instanceUniqueId/sales/promostores", exact: true, title: "Promo Stores" },
  { path: "/instance/:instanceUniqueId/sales/analytics", exact: true, title: "Sales Analytics" },
  { path: "/instance/:instanceUniqueId/sales/dashboard", exact: true, title: "Sales Dashboard" },
  { path: "/instance/:instanceUniqueId/sales", exact: true, title: "Sales Dashboard" },

  { path: "/instance/:instanceUniqueId/production/dashboard", exact: true, title: "Production Dashboard" },
  { path: "/instance/:instanceUniqueId/purchasing/dashboard", exact: true, title: "Purchasing Dashboard" },
  { path: "/instance/:instanceUniqueId/production/analytics", exact: true, title: "Production Analytics" },
  { path: "/instance/:instanceUniqueId/production/materials-management", exact: true, title: "Materials" },
  { path: "/instance/:instanceUniqueId/production/department-management", exact: true, title: "Departments" },
  { path: "/instance/:instanceUniqueId/production/machines-management", exact: true, title: "Machines" },
  { path: "/instance/:instanceUniqueId/production/charge-strategies", exact: true, title: "Charge Strategies" },
  { path: "/instance/:instanceUniqueId/production/:department/:tabType?", exact: true, title: "Production" },

  { path: "/instance/:instanceUniqueId/finance/dashboard", exact: true, title: "Finance Dashboard" },
  { path: "/instance/:instanceUniqueId/finance/billing", exact: true, title: "Billing" },
  { path: "/instance/:instanceUniqueId/finance/invoicing", exact: true, title: "Invoicing" },
  { path: "/instance/:instanceUniqueId/finance", exact: true, title: "Finance Dashboard" },
  { path: "/instance/:instanceUniqueId/invoicing/import", exact: true, title: "Invoice Import" },

  { path: "/instance/:instanceUniqueId/shipping/receiving", exact: true, title: "Shipping Labels" },
  { path: "/instance/:instanceUniqueId/shipping/warehouse-builder", exact: true, title: "Warehouse" },

  { path: "/instance/:instanceUniqueId/reports/commissions", exact: true, title: "Commissions" },
  { path: "/instance/:instanceUniqueId/reports/sales", exact: true, title: "Sales Report" },
  { path: "/instance/:instanceUniqueId/reports/sales-rep", exact: true, title: "Sales Report" },
  { path: "/instance/:instanceUniqueId/reports/documents", exact: true, title: "Documents" },
  { path: "/instance/:instanceUniqueId/reports/product-sold", exact: true, title: "Products Sold" },
  { path: "/instance/:instanceUniqueId/reports/supplier", exact: true, title: "Supplier Report" },
  { path: "/instance/:instanceUniqueId/reports/client-invoicing", exact: true, title: "Client Invoicing" },
  { path: "/instance/:instanceUniqueId/reports/work-in-progress", exact: true, title: "Work in Progress" },
  { path: "/instance/:instanceUniqueId/reports/ar-aging", exact: true, title: "AR Aging" },
  { path: "/instance/:instanceUniqueId/reports/dashboard", exact: true, title: "Reports" },
  { path: "/instance/:instanceUniqueId/reports", exact: true, title: "Reports" },

  { path: "/instance/:instanceUniqueId/core-network/work-requests/:id", exact: true, title: "Work Request" },
  { path: "/instance/:instanceUniqueId/core-network/work-requests", exact: true, title: "Work Requests" },
  { path: "/instance/:instanceUniqueId/core-network/talent/:id", exact: true, title: "Talent Profile" },
  { path: "/instance/:instanceUniqueId/core-network/talent", exact: true, title: "Talent" },
  { path: "/instance/:instanceUniqueId/core-network/matches", exact: true, title: "Matches" },
  { path: "/instance/:instanceUniqueId/core-network/settings", exact: true, title: "Core Network Settings" },
  { path: "/instance/:instanceUniqueId/core-network/dashboard", exact: true, title: "Core Network" },
  { path: "/instance/:instanceUniqueId/core-network", exact: true, title: "Core Network" },
  { path: "/instance/:instanceUniqueId/decoration-network/:section?/:id?", exact: true, title: "Core Network" },

  { path: "/instance/:instanceUniqueId/settings/users", exact: true, title: "Users" },
  { path: "/instance/:instanceUniqueId/settings/global-settings/:tabType?/:settingType?", exact: true, title: "Global Settings" },
  { path: "/instance/:instanceUniqueId/settings/crm", exact: true, title: "Global Settings" },
  { path: "/instance/:instanceUniqueId/settings", exact: true, title: "Global Settings" },
  { path: "/instance/:instanceUniqueId/website-sync", exact: true, title: "Website Settings" },

  { path: "/instance/:instanceUniqueId/operations/management", exact: true, title: "Operations" },
  { path: "/instance/:instanceUniqueId/operations/dashboard", exact: true, title: "Operations" },
  { path: "/instance/:instanceUniqueId/operations/sales-operations", exact: true, title: "Sales Operations" },
  { path: "/instance/:instanceUniqueId/ai/:tabType?", exact: true, title: "Core Brain" },
  { path: "/instance/:instanceUniqueId/dashboard/promoshowcase", exact: true, title: "Promo Showcase" },
  { path: "/instance/:id/get-started", exact: true, title: "Get Started" },
  { path: "/instance/:instanceUniqueId/add-payment-method", exact: true, title: "Payment Method" },
  { path: "/instance/:instanceUniqueId/connect/suppliers", exact: true, title: "Suppliers" },
  { path: "/instance/:instanceUniqueId/connect/products", exact: true, title: "Products" },
  { path: "/instance/:instanceUniqueId/connect/feed-and-activity", exact: true, title: "Dashboard" },
  { path: "/instance/:instanceUniqueId/reports/supplier-bill-pipeline", exact: true, title: "Supplier Bill Pipeline" },
  { path: "/instance/:instanceUniqueId/connect", exact: true, title: "Dashboard" },
  { path: "/instance/:instanceUniqueId", exact: true, title: "Dashboard" },
];

const cleanParameter = (value) => {
  if (value == null || String(value).trim() === "") return "";
  try {
    return decodeURIComponent(String(value)).trim();
  } catch (_error) {
    return String(value).trim();
  }
};

export const resolvePageName = (pathname) => {
  if (typeof pathname !== "string" || !pathname.trim()) return "";

  for (const definition of routeTitles) {
    const match = matchPath(pathname, {
      path: definition.path,
      exact: definition.exact,
      strict: false,
    });
    if (!match) continue;

    if (typeof definition.title === "function") {
      const params = Object.fromEntries(
        Object.entries(match.params || {}).map(([key, value]) => [key, cleanParameter(value)])
      );
      return definition.title(params) || "";
    }
    return definition.title || "";
  }

  return "";
};

export const formatPageTitle = (pageName) => {
  const cleanName = typeof pageName === "string" ? pageName.trim() : "";
  return cleanName ? `${cleanName} | ${APP_TITLE}` : APP_TITLE;
};

export const resolvePageTitle = (pathname) => formatPageTitle(resolvePageName(pathname));
